import { h, Component, Fragment, createRef } from 'preact';

export default class FilterComponent extends Component {
    constructor() {
        super();
        this.state = {
            showFilter: false
        };

        this.closeOnDeselect = this.closeOnDeselect.bind(this);
        this.ref = createRef();
    }

    toggleDropdown() {
        this.setState({ showFilter: !this.state.showFilter });
    }

    closeOnDeselect(event) {
        // TODO find a better solution then this document event mount for closing div
        if (this.ref && !this.ref.current.contains(event.target)) {
            this.setState({showFilter: false});
        }
    }

    componentDidMount() {
        // console.log('%cTRACE: componentDidMount', 'color: green; font-weight: 900; background: white');
        document.addEventListener("mousedown", this.closeOnDeselect);
    }

    componentWillUnmount() {
        document.removeEventListener("mousedown", this.closeOnDeselect);
    }

    render() {
        const self = this;
        const selectedIds = {};
        self.props.selected.forEach(x => {
            selectedIds[x.id] = 1;
        });

        return (
            <Fragment>
                <div class="filter" ref={self.ref}>
                    {/* Filter Button */}
                    <button class={`filter-toggle ${self.props.options?.length > 0 ? '' : 'disabled'}`} disabled={!self.props.options?.length} onclick={() => self.toggleDropdown()}>
                        {self.props.message}
                        <span class={`caret ${self.state.showFilter ? 'selected' : ''}`}></span>
                    </button>
                    {/* Filter Area */}
                    <ul class={`filter-menu ${self.state.showFilter ? 'show-filter' : 'hide-filter'}`}>
                        {
                            self.props.options?.map(option => {
                                return (
                                    <li key={option.id} class="list">
                                        <button
                                            class={`${selectedIds[option.id] ? 'selected' : ''}`}
                                            data-ga={`${self.props.ga} ${selectedIds[option.id] ? 'Deselect' : 'Select'}`}
                                            onclick={() => {
                                                self.props.onSelect(option);
                                                self.toggleDropdown();
                                            }}
                                        >{option.label}
                                        </button>
                                    </li>
                                );
                            })
                        }
                    </ul>
                    {/* Selected Filters */}
                    <div class="filter-selection-container">
                        {
                            self.props.selected?.map(option => {
                                return (
                                    <button key={option.id} data-ga={`${self.props.ga} Deselect`} class="tag" onclick={() => self.props.onSelect(option)}>
                                        <span class="tag-name">{option.label}</span>
                                        <span class="close-tag">&times;</span>
                                    </button>
                                );
                            })
                        }
                    </div>
                </div>
            </Fragment>
        );
    }
}
